import React, { useState } from "react";
import { Wrench, CalendarClock, MapPin, ListChecks } from "lucide-react";
import { PageHeader } from "@/components/ds";
import { ServicesPanel } from "./services/ServicesPanel";
import { AppointmentTypesPanel } from "./services/AppointmentTypesPanel";
import { ServiceAreasPanel } from "./services/ServiceAreasPanel";
import { IntakeQuestionsPanel } from "./services/IntakeQuestionsPanel";

type Tab = "services" | "appointment-types" | "service-areas" | "intake";

const TABS: { key: Tab; label: string; icon: typeof Wrench }[] = [
  { key: "services", label: "Services", icon: Wrench },
  { key: "appointment-types", label: "Appointment types", icon: CalendarClock },
  { key: "service-areas", label: "Service areas", icon: MapPin },
  { key: "intake", label: "Intake questions", icon: ListChecks },
];

export default function Services() {
  const [tab, setTab] = useState<Tab>("services");
  return (
    <div data-testid="page-services" className="space-y-6">
      <PageHeader title="Services" description="What your business offers, how it's booked, where you work and what you ask." testid="services-header" />
      <div className="flex gap-1 overflow-x-auto border-b border-slate-200" data-testid="svc-tabs">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button key={key} onClick={() => setTab(key)} data-testid={`svc-tab-${key}`}
            className={`-mb-px flex items-center gap-2 whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
              tab === key ? "border-blue-600 text-blue-700" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
            <Icon className="h-4 w-4" /> {label}
          </button>
        ))}
      </div>
      {tab === "services" && <ServicesPanel />}
      {tab === "appointment-types" && <AppointmentTypesPanel />}
      {tab === "service-areas" && <ServiceAreasPanel />}
      {tab === "intake" && <IntakeQuestionsPanel />}
    </div>
  );
}
